import { ReactElement, useState } from "react";
import { Modal, Select, Radio } from 'antd';

const { Option } = Select;

type Props = {
  visible: boolean;
  onClose: () => void;
  onDone: (clubId: string) => void
  user: any;
  clubs: any[]
};

export function SetPriorityModal({ visible, onClose, user, clubs, onDone }: Props): ReactElement {

  const [selectedClub, setSelectedClub] = useState<string>("");

  const onFinish = () => {
    if (selectedClub === "") onClose();
    else onDone(selectedClub);
  }

  const handleChange = (value: string) => {
    setSelectedClub(value);
    console.log(`Selected: ${value}`);
  }

  const children = () => {
    const availableClubs = clubs.filter(club => {
      if (club.prority) {
        console.log(user.id);
        return club.priority.findIndex((p: string) => p === user.id) === -1;
      }
      return true;
    });

    const options = availableClubs.map((club) => (
      <Option key={club.clubId} value={club.firestoreRef}>{club.name}</Option>
    ))

    return options;
  }

  return (
    <Modal
      title="Set Priority"
      centered
      visible={visible}
      onOk={onFinish}
      okText="Set Priority"
      onCancel={onClose}
    >
      <Select
        placeholder="Please select a club"
        onChange={handleChange}
        style={{ width: '100%' }}
      >
        {children()}
      </Select>
    </Modal>
  );
}
